import './Home.css';
import { NavLink } from "react-router";

function Home() {
    const publicUrl = process.env.PUBLIC_URL;

    return (
        <div>
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td width="175" align="center">
                            <img width="150" border="0" src={`${publicUrl}/images/home/annabel-butler.jpg`}/><br/><br/>
                            Image credit: Andrew Treloar
                        </td>
                        <td valign="top">
                            <div className="news-text-no-border">Represented by Stella Downer Fine Art, Sydney</div>
                            <br/><br/>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br/>

            <div className="news-text">News &amp; Exhibitions</div>
            <br/>
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td width="175" align="center">
                            <NavLink to="/solo/106"><img width="150" border="0" src={`${publicUrl}/images/galleries/106/01.jpg`}/></NavLink>
                        </td>
                        <td valign="top">
                            <b>2026 Solo Exhibition</b>
                            <br/>
                            <NavLink to="/solo/106">The Tractor Chapters</NavLink>

                            <br/><br/>
                            Ironbark Gallery
                            <br/>
                            Strathfield Library &amp; Innovation Hub
                            <br/>
                            65-67 Rochester Street, Homebush

                            <br/><br/>
                            Exhibition Dates: 14 August - 11 October 2026
                            <br/>
                            Gallery Hours: Mon-Fri 9.30am-6.30pm, Sat &amp; Sun 9am-1pm
                            <br/>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br/>
            <br/>
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td width="175" align="center">
                            <NavLink to="/group/107"><img width="150" border="0" src={`${publicUrl}/images/galleries/107/01.jpg`}/></NavLink>
                        </td>
                        <td valign="top">
                            <br/>
                            Finalist, <NavLink to="/group/107">Portia Geach Memorial Award</NavLink>
                            <br/>
                            18 September - 1 November

                            <br/><br/>
                            S.H. Ervin Gallery
                            <br/>
                            Sydney
                        </td>
                    </tr>
                </tbody>
            </table>
            <br/>
            <br/>
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td width="175" align="center">
                            <NavLink to="/group/105"><img width="150" border="0" src={`${publicUrl}/images/galleries/105/01.jpg`}/></NavLink>
                        </td>
                        <td valign="top">
                            <br/>
                            Finalist, <NavLink to="/group/105">The Lester Prize</NavLink>
                            <br/>
                            Opening: Friday 9 October, 6.30-9pm
                            <br/>
                            10 October - 29 November 2026

                            <br/><br/>
                            WA Museum Boola Bardip
                            <br/>
                            Perth
                        </td>
                    </tr>
                </tbody>
            </table>
            <br/>
            <br/>
            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td width="175" align="center">
                            <NavLink to="/prizes/099"><img width="150" border="0" src={`${publicUrl}/images/galleries/099/02.jpg`}/></NavLink>
                        </td>
                        <td valign="top">
                            <br/>
                            <NavLink to="/prizes/099">9x5 Landscape Prize</NavLink>
                            <br/>
                            2025
                            <br/>
                            <b>Winner</b>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br/>
            <br/>

            {/* <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                <tbody>
                    <tr>
                        <td width="175" align="center">
                            <img width="150" border="0" src={`${publicUrl}/images/home/air-house.jpg`}/>
                        </td>
                        <td valign="top">
                            <b>2024 Georges River Artist in Residence</b> <br/><br/>
                            <a target="_blank" href="https://www.georgesriver.nsw.gov.au/Community/Art-and-Culture/Hurstville-Museum-Gallery/Artist-in-Residence"> Find out more</a>
                        </td>
                    </tr>
                </tbody>
            </table>   */}

            <div className="news-text">Teaching 2026</div>
            <br/>
            The National Art School
            <br/>
            Painting Lecturer,
            <br/>
            National Art School Short Courses <a href="https://nas.edu.au/" target="_blank">https://nas.edu.au/</a>
            <br/><br/>
        </div>
    )
}

export default Home;
